import { type Config } from '../config.schema';

declare global {
  interface Window {
    carlAllConfig?: Config[];
  }
}

export const getCarlConfig: () => Config = () => ({
  origin: window.location.origin,
  name: 'Clean Air Routes London',
  rootElement: '#root',
  logo: 'logo.svg',
  favicon: 'favicon.ico',
  mainColor: '#0B8722',
  bounds: {
    southwest: [51.484, -0.181],
    northeast: [51.52, -0.107],
  },
});

export function getConfigFromOrigin(configs: Config[], targetUrl: string = window.location.href): Config | undefined {
  const targetOrigin = new URL(targetUrl).origin;

  let matchedConfig = configs.find((config) => {
    const configOrigin = new URL(config.origin).origin;
    return configOrigin === targetOrigin;
  });

  if (!matchedConfig) {
    matchedConfig = configs.find((config) => targetUrl.startsWith(config.origin));
  }

  return matchedConfig;
}

export function getConfig(allConfig?: Config[]): Config {
  const configs = allConfig || window.carlAllConfig;

  if (!configs || configs.length === 0) {
    return getCarlConfig();
  }

  const matchedConfig = getConfigFromOrigin(configs);
  return matchedConfig || getCarlConfig();
}

export function applyClientConfig(config?: Config): void {
  if (config?.favicon) {
    const link = (document.querySelector("link[rel~='icon']") as HTMLLinkElement) || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = config.favicon;
    if (!document.querySelector("link[rel~='icon']")) {
      document.getElementsByTagName('head')[0].appendChild(link);
    }
  }

  if (config?.styles) {
    const styleElement = document.createElement('style');
    styleElement.textContent = config.styles;
    document.head.appendChild(styleElement);
  }

  if (config?.mainColor) {
    document.documentElement.style.setProperty('--main-color', config.mainColor);
  }
}
